import { render, staticRenderFns } from "./DunningEnable.vue?vue&type=template&id=ec688406&"
import script from "./DunningEnable.vue?vue&type=script&lang=js&"
export * from "./DunningEnable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports